<template>
  <el-dialog title="排班" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <div v-for="(item,index) in form.conditionList" :key="index" class="full-box">
        <el-form-item label="值班人：" :prop="`conditionList[${index}].userId`" :rules="{required: true,message: '请选择',trigger: 'change'}">
          <el-select v-model="item.userId" placeholder="请选择" clearable size="small">
            <el-option v-for="(item,index) in serviceOptions" :key="index" :label="item.realName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值班时间：" :prop="`conditionList[${index}].date`" :rules="{required: true,message: '请填写',trigger: 'change'}">
          <el-date-picker type="dates" :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="item.date" placeholder="请选择"></el-date-picker>
        </el-form-item>
        <div class="full-icon">
          <i class="el-icon-plus" @click="handleAddItem"></i>
          <i class="el-icon-minus" @click="handleDeleteItem(index)" v-if="form.conditionList.length > 1"></i>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import courseSubjectBarrierDutyTeacher from '@/api/course/courseSubjectBarrierDutyTeacher'

function initFormBean() {
  const formBean = {
    id: null,
    conditionList: [{ userId: '', date: [] }],
  }
  return formBean
}

export default {
  props: ['serviceOptions'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {

      },
      rowItem: null,
      pickerOptions: {
        disabledDate: (time) => {
          let _f = new Date(this.rowItem.startTime).getTime();
          let _l = new Date(this.rowItem.endTime).getTime();
          return time.getTime() < _f || time.getTime() > _l
        }
      },
    }
  },
  created() {

  },
  methods: {

    handleDeleteItem(index) {
      this.form.conditionList.splice(index, 1)
    },
    handleAddItem() {
      this.form.conditionList.push({ userId: '', date: [] })
    },
    handleScheduling(row) {
      this.rowItem = row
      this.formVisible = true
    },
    doCreate() {
      let { conditionList } = this.form;
      conditionList.forEach(item => {
        item.date = item.date.toString()
      })
      let params = {
        barrierId: this.rowItem.id,
        dutyStr: JSON.stringify(conditionList)
      }
      courseSubjectBarrierDutyTeacher.create(params).then(res => {
        if (res.code === '0') {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 47%;
  display: inline-block;
  vertical-align: top;
}
::v-deep .el-select {
  width: 100%;
}
.full-box {
  display: flex;
  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;
    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
</style>
